import React, { useState } from 'react';
import NumberPad from '../components/NumberPad';
import Dropzone from '../components/DropZone';
import ProgressBar from '../components/ProgressBar';
import CopyIcon from '../components/CopyIcon';

import { getUploadFileContext } from '../models/File';

import { withTranslation  } from 'react-i18next';
import { uploadFile } from '../models/File';
import { log } from '../helper';

class Upload extends React.Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.state = {
      isUploading: false,
      isLoading: false,
      progress: 0,
      key: "",
      error: "",
    }
  }

  render() {
    const { t } = this.props;

    const isExist = () => {
      return 'file' in this.state && this.state.file
    }

    const isKey = () => {
      return 'key' in this.state && this.state.key !== ""
    }

    const initFile = (file) => {
      this.setState(Object.assign({}, this.state, {
        file: file,
        id: 1,
        expiration: '86400',
        isUploading: false,
        isLoading: false,
        progress: 0,
        key: "",
        expiredAt: "",
        copyUrl: "",
        isCopy: false,
        error: "",
      }))
    }

    const isUploading = () => {
      return this.state.isUploading === true
    }

    const isLoading = () => {
      return this.state.isLoading === true
    }

    const initUpload = () => {
      this.setState(Object.assign({}, this.state, {
        isUploading: true,
        isLoading: true,
        progress: 0,
      }))
    }

    const beforeUpload = () => {
      this.setState(Object.assign({}, this.state, {
        isUploading: true,
        isLoading: false,
        progress: 0,
      }))
    }

    const setUploading = (percent) => {
      this.setState(Object.assign({}, this.state, {
        isUploading: true,
        isLoading: false,
        progress: percent,
      }))
    }

    const uploadFail = (error) => {
      this.setState(Object.assign({}, this.state, {
        error,
      }))
    }

    // Handle file selection
    const handleFileChange = (file) => {
      // if file is uploding, cannot submit new file
      if (this.state.isUploading && this.state.progress < 100) {
        alert("Please wait file uploading.");
        return;
      }
      initFile(file);
    };

    const uploadSuccess = (_resp) => {
      const key = _resp.key;
      const expiredAt = _resp.expired_at.replace('T', ' ').replace(/\.\w+/i, '');
      // cloud storage resp
      return (resp) => {
        log(key, expiredAt)
        log(_resp)
        log(resp)
        if (resp.status !== 200) {
          alert(`${_resp.key}: ${resp.status}: ${resp.message}`);
          return;
        }
        this.setState(Object.assign({}, this.state, {
          key,
          expiredAt,
          copyUrl: `${window.location.origin}/${key}`,
        }))
      }
    };
  
    // Handle form submission
    const handleFormSubmit = (e) => {
      e.preventDefault(); // Prevent page reload on form submit
      if (isExist()) {
        // Here you can send the file to a server using APIs like Axios or Fetch

        initUpload();

        getUploadFileContext({
          filename: this.state.file.name,
          filetype: this.state.file.type,
          filesize: this.state.file.size,
          password: this.state.password,
          expiration: this.state.expiration,
        }).then((resp) => resp.json())
          .then((resp) => { beforeUpload(); return resp; })
          .then((resp) => uploadFile(resp.url, this.state.file, setUploading, uploadSuccess(resp)))
          .catch((resp) => {
            uploadFail(resp.message)
          });
      } else {
        alert("No file selected. Please select a file first.");
      }
    };
  
    const handleExpirationChange = (id, newExpiration) => {
      this.setState(Object.assign({}, this.state, {
          id: id,
          expiration: newExpiration,
      }));
    };
  
    const handlePasswordChange = (value) => {
      this.setState(Object.assign({}, this.state, {
          password: value,
      }));
      log(this.state)
    };

    return (
      <div className="container mt-5">
        <h1 className="text-center">{t('title')}</h1>
        <form onSubmit={handleFormSubmit} className="mt-4">
          <Dropzone onDrop={files => handleFileChange(files[0])}></Dropzone>
          {isExist() && (
            <div className="">
              <label htmlFor="fileInput" className="form-label">
                <strong>{t('files_page_selected')} </strong>
                {this.state.file.name}
              </label>
            </div>
          )}

          {!isUploading() && isExist() && (
              <div className="mt-2">
                  {/* <p className="text-success">Selected File: {file.obj.name}</p> */}
                  <label className="form-label mt-2">
                    <strong>{t('files_page_expiration')} </strong>
                  </label>
                  <select
                      className="form-select"
                      value={this.state.expiration}
                      onChange={(e) =>
                          handleExpirationChange(this.state.id, e.target.value)
                      }
                  >
                      <option value="900">15 minutes</option>
                      <option value="3600">1 hour</option>
                      <option value="21600">6 hours</option>
                      <option value="43200">12 hours</option>
                      <option value="86400" selected>1 day</option>
                      <option value="259200">3 days</option>
                      <option value="604800">7 days</option>
                      <option value="1209600">14 days</option>
                      <option value="2592000">30 days</option>
                  </select>
  
                  <label className="form-label mt-2">
                    <strong>{t('files_page_numpasswd')} </strong>
                    {t('files_page_blank_passwd')}
                  </label>
                  <NumberPad setValue={handlePasswordChange}/>
              </div>
          )}

          {!isUploading() && isExist() && (
            <div class="d-grid gap-2 my-5">
              <button class="btn btn-primary" type="submit">{t('files_page_upload_btn')}</button>
            </div>
          )}

          {isUploading() && (isLoading()
            ? <ProgressBar isLoading={true} />
            : <ProgressBar progress={this.state.progress} />
          )}

          {isKey() && (
            <div>
              <strong>Link: </strong>
              <a href={this.state.copyUrl}>{this.state.copyUrl}</a>
              <CopyIcon data={this.state.copyUrl} />

              <p><strong>Expired At: </strong>{this.state.expiredAt}</p>
            </div>
          )}

          {this.state.error !== "" && (
            <p className="text-danger">
              <strong>Error: {this.state.error}</strong>
            </p>
          )}

        </form>
      </div>
    );
  }
};

export default withTranslation()(Upload);